import React from 'react';
import { Namespace } from '../../../translation/namespace';
import { useBlockContext, useRefreshBlock } from '../../../_lib/BlockFetcher';
import {
  BlockInteractions,
  Views as BlockInteractionsViews,
  DISPLAY_TYPE,
  createButtonObject,
} from '../../../components/organisms/BlockInteractions';
import { Icons } from '../../../components/atoms/SVG';
import { BlockType } from '../../../types/api/ElementType';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { RoleSpecificAreaGroupsDefaultView } from '../views/RoleSpecificAreaGroupsDefaultView';
import { RoleSpecificAreaGroupsEditView } from '../views/RoleSpecificAreaGroupsEditView';
import { DefaultView, OptionalEditView, Views } from '../../../types/BlockWithViews';

export type RoleSpecificAreaGroupsInteractionsProps = Views<
  DefaultView<RoleSpecificAreaGroupsDefaultView> & OptionalEditView<RoleSpecificAreaGroupsEditView>
>;

export function RoleSpecificAreaGroupsInteractions({ views, activeView }: RoleSpecificAreaGroupsInteractionsProps) {
  const { t } = useSonTranslation('AreaGroups');

  const { uuid } = useBlockContext();
  const { refreshCount } = useRefreshBlock();
  const buttons = views.edit
    ? createButtonObject(
        BlockInteractionsViews.EDIT,
        Icons.EDIT_PENCIL,
        `${Namespace.AreaGroups}:roleSpecificAreaGroups.views.edit`,
        DISPLAY_TYPE.COLLAPSIBLE,
        <RoleSpecificAreaGroupsEditView {...views.edit} />
      )
    : {};

  return (
    <BlockInteractions
      key={refreshCount}
      refreshCount={refreshCount}
      uuid={uuid}
      elementType={BlockType.rolespecificareagroups}
      headline={{
        text: t('roleSpecificAreaGroups.blockTitle'),
        hierarchy: 3,
        visible: true,
      }}
      activeView={activeView}
      views={views}
      buttons={buttons}
      alwaysShowInfo
    >
      <RoleSpecificAreaGroupsDefaultView {...views.default} />
    </BlockInteractions>
  );
}
